import { Popover, MenuList, MenuItem, ListItemText, Divider } from '@mui/material';
import { colors, Tooltip } from '@sweep-io/sweep-design';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';
import { useCanDeployOrRequestToAnyOrg } from '../../../../common/permissions/useCanDeployOrRequestToAnyOrg';

export type SfFunnelMenuAction = 'deploy' | 'remove' | 'delete';

interface SfFunnelMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onClick: (action: SfFunnelMenuAction) => void;
  disabled?: boolean;
}

export const SfFunnelMenu = ({
  anchorEl,
  onClose,
  onClick,
  disabled = false,
}: SfFunnelMenuProps) => {
  const { deployFromFunnelLabel } = useFeatureToggle();

  const { canDeployOrRequestToAnyOrg } = useCanDeployOrRequestToAnyOrg();
  const canDeploy = canDeployOrRequestToAnyOrg();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: -7,
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: -8,
      }}
    >
      <MenuList sx={{ minWidth: '292px' }}>
        <MenuItem onClick={() => onClick('remove')} disabled={disabled}>
          <ListItemText>Remove from Canvas</ListItemText>
        </MenuItem>
        {deployFromFunnelLabel && (
          <Tooltip
            title={canDeploy ? undefined : "You don't have permissions to deploy"}
            placement="right"
          >
            <span>
              <MenuItem onClick={() => onClick('deploy')} disabled={disabled || !canDeploy}>
                <ListItemText>Deploy</ListItemText>
              </MenuItem>
            </span>
          </Tooltip>
        )}

        <Divider />
        <MenuItem onClick={() => onClick('delete')} disabled={disabled}>
          <ListItemText sx={{ color: colors.blush[600] }}>Delete funnel</ListItemText>
        </MenuItem>
      </MenuList>
    </Popover>
  );
};
